module.exports = __webpack_public_path__ + "img/goals_dashboard_white.f8ba7646.svg";